import type { SVGProps } from 'react'

const ActionableLocationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M10.1505 30.332L15.0794 30.332"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M44.5889 30.332L49.5177 30.332"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M29.5 10.4336L29.5 15.3625"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M29.5 45.6367L29.5 50.5656"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M22.8795 32.3486C21.2398 31.9386 21.018 29.6991 22.5455 28.9756L34.828 23.1576C36.3565 22.4335 37.9493 24.0263 37.2253 25.5548L31.4072 37.8373C30.6837 39.3648 28.4442 39.143 28.0342 37.5033L27.2652 34.4273C27.104 33.7824 26.6004 33.2788 25.9555 33.1176L22.8795 32.3486Z"
      stroke="#0066FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="29.858"
      cy="30.1422"
      r="17.275"
      stroke="#0066FF"
      strokeWidth="2"
    />
  </svg>
)

export default ActionableLocationIcon
